'use strict';

var Sugar = require('sugar-core'),
    stringSpacify = require('./internal/stringSpacify');

Sugar.String.defineInstance({

  'spacify': function(str) {
    return stringSpacify(str);
  }

});

module.exports = Sugar.String.spacify;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/spacify.js
// module id = 927
// module chunks = 0